exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"menuText": "#000",
	"menuActiveText": "#F0426C",
	"subMenuActiveText": "#F0426C",
	"menuBg": "#fff",
	"menuHover": "#FDECF0",
	"subMenuBg": "#fff",
	"subMenuHover": "#FDECF0",
	"sideBarWidth": "3.2rem"
};